import React from 'react'

function HomeHero() {
  return (
  
    <>

<section class="bg-no-repeat bg-cover bg-[#04347c] h-[450px] md:h-[550px] items-center">
    <div class="pt-8 py-4 px-4 mx-auto max-w-screen-xl text-center lg:py-32 lg:px-12">
        <a href="#" class="inline-flex justify-between items-center py-1 px-1 pr-4 mb-7 text-sm text-black bg-white rounded-full hover:bg-black hover:text-white" role="alert">
            <span class="text-sm font-medium px-2 py-1">We invest in the world’s potential</span> 
        </a>
        <div className='h-12 sm:hidden '></div>
        <h1 class="mb-4 text-lg font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl ">Welcome to Tisson Lanka (PVT) LTD</h1>
        <p class="mb-8 mt-4 text-sm font-normal text-white lg:text-xl sm:px-16 xl:px-48 ">Bringing World-Class Home Appliances to Your Doorstep & Empowering Your Home with Innovation</p>
        <div className='h-12 sm:hidden '></div>
        <div class="flex flex-col mb-8 space-y-10 md:mb-16 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
            <a href="/Contact" class="inline-flex justify-center items-center md:py-3 md:px-5 py-2 px-3 text-base font-medium text-center text-white rounded-lg border border-gray-300 hover:bg-white hover:text-black focus:ring-4 focus:ring-gray-100">
                
                Contact Now
            </a> 
       </div> 
    </div>
</section>


    </>
  )
}

export default HomeHero